import ActionTypes from '../actions/ActionTypes'

export const rejectTrigger = (trip, plan) => ({
  type: ActionTypes.PLAN_TRIGGER_REJECTED,
  payload: { trip, plan }
})

export const rejectStopTrigger = (trip, plan) => ({
  type: ActionTypes.PLAN_STOP_HANDLED,
  payload: { trip, plan }
})
  
export const changeLanguage = (language) => ({
  type: ActionTypes.CHANGE_LANGUAGE, 
  payload: language
})

export const toggleModal = (modalKey, inModal = false) => ({
  type: ActionTypes.TOGGLE_MODAL,
  value: inModal,
  key: modalKey
})